/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/search-results/__generated__/searchResultsAsyncQuery.graphql.ts
 */

export const SEARCH_RESULTS_ASYNC_QUERY_PERSISTED_ID = 'fd9e027ab1a7b9043e8dd3974fd00dc2fc12abdcf35c7cb3132f5181c825c983';
export const SEARCH_RESULTS_ASYNC_QUERY_OPERATION_NAME = 'searchResultsAsyncQuery';
